import { BrowserRouter, Route } from 'react-router-dom'

import reactComponentLoader from 'scripts/react-component-loader'

import { EntryKey } from './'

const EntryKeyApp = dataset => (
  <BrowserRouter>
    <Route component={props => <EntryKey {...dataset} {...props} />} />
  </BrowserRouter>
)

reactComponentLoader(EntryKeyApp, '[data-entry-key]')
